"use client"

import { useState } from "react"

type FooterNewsletterProps = {
  title?: string
  text?: string
}

export default function FooterNewsletter({ title, text }: FooterNewsletterProps) {
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<"idle" | "sending" | "done" | "error">("idle")

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!email) return
    setStatus("sending")
    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      })
      if (!res.ok) throw new Error("failed")
      setStatus("done")
      setEmail("")
    } catch {
      setStatus("error")
    }
  }

  return (
    <div>
      <h3 className="text-[10px] font-semibold uppercase tracking-[0.3em] text-[#3D5240]">
        {title || "Newsletter"}
      </h3>
      {text && (
        <p className="mt-3 max-w-[300px] text-[12px] font-light leading-6 text-[#5C5040]">
          {text}
        </p>
      )}
      {status === "done" ? (
        <p className="mt-5 text-[13px] font-light leading-6 text-[#3D5240]">
          Subscribed — thank you!
        </p>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="mt-5 flex max-w-[340px] border-b border-[#1A1612]/25 focus-within:border-[#3D5240]"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={status === "error" ? "Try again..." : "Email address"}
            required
            className="min-w-0 flex-1 bg-transparent py-3 text-sm text-[#1A1612] outline-none placeholder:text-[#5C5040]/60"
          />
          <button
            type="submit"
            disabled={status === "sending"}
            className="px-2 text-[11px] font-medium uppercase tracking-[0.22em] text-[#3D5240] transition-colors hover:text-[#2F4234] disabled:opacity-50"
          >
            {status === "sending" ? "..." : "Subscribe"}
          </button>
        </form>
      )}
    </div>
  )
}
